import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../lib/cn.js";
/** A small status label. `tone` says what kind of state it is; the wording comes from the caller's i18n. */
export const badgeVariants = cva("inline-flex shrink-0 items-center gap-1.5 rounded-full font-medium whitespace-nowrap ring-1 ring-inset", {
    variants: {
        tone: {
            neutral: "bg-muted text-muted-foreground ring-border",
            primary: "bg-primary-soft text-primary ring-primary/15",
            success: "bg-success-soft text-success ring-success/15",
            warning: "bg-warning-soft text-warning ring-warning/20",
            danger: "bg-destructive-soft text-destructive ring-destructive/15",
            info: "bg-info-soft text-info ring-info/15",
            outline: "bg-transparent text-foreground ring-border",
        },
        size: {
            sm: "px-2 py-0.5 text-[11px] leading-4",
            md: "px-2.5 py-0.5 text-xs leading-5",
        },
    },
    defaultVariants: { tone: "neutral", size: "md" },
});
export function Badge({ className, tone, size, dot = false, children, ...props }) {
    return (_jsxs("span", { className: cn(badgeVariants({ tone, size }), className), ...props, children: [dot ? _jsx("span", { className: "size-1.5 rounded-full bg-current", "aria-hidden": true }) : null, children] }));
}
//# sourceMappingURL=badge.js.map